import React, { useState, useMemo } from "react";
import AgentLayout from "../components/AgentLayout";
import NavButton from "../components/NavButton";
import axiosInstance from "../../../utils/axiosInstance";
import EasyGrid from "../../client/components/EasyGrid";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
function escapeHtml(str = "") {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}
function toLocalString(d) {
  const pad = (x) => String(x).padStart(2, "0");
  return (
    `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ` +
    `${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`
  );
}

const FinalSheet = () => {
  const today = new Date();
  const year = today.getFullYear();
  const monthIndex = today.getMonth(); // 0-based: 0 = Jan
  const dayOfMonth = today.getDate();

  const todayStart = new Date(year, monthIndex, dayOfMonth, 0, 0, 0, 0);
  const todayEnd = new Date(year, monthIndex, dayOfMonth, 23, 59, 59, 999);

  const [startDate, setStartDate] = useState(todayStart);
  const [endDate, setEndDate] = useState(todayEnd);
  const [profitData, setProfitData] = useState([]);
  const [lossData, setLossData] = useState([]);

  const [allProfitData, setAllProfitData] = useState([]);
  const [allLossData, setAllLossData] = useState([]);

  const [plusTotal, setPlusTotal] = useState(0);
  const [minusTotal, setMinusTotal] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [hideZero, setHideZero] = useState(false);

  const userInfo = useSelector((state) => state.userStore);
  const navigate = useNavigate();

  let username = "";
  let userId = "";
  let sponserId = "";
  if (
    userInfo !== null &&
    userInfo !== undefined &&
    userInfo.data !== null &&
    userInfo.data !== undefined
  ) {
    username = userInfo?.data?.uname;
    userId = userInfo?.data?._id;
    sponserId = userInfo?.data?.sponser_id;
  }

  const [pageSize, setPageSize] = useState(10);
  const handleUserClick = async (user) => {
    if (user.user_id == userId) {
      navigate("/agent/accounts/chart");
    } else if (user.user_id == sponserId) {
      navigate("/agent/accounts/chart");
    } else {
      navigate("/agent/accounts/chart/" + user.user_id);
    }
  };

  const formatTruncate = (value) => {
    let num = Math.round(value);
    const truncated = Math.floor(num * 1000) / 1000;

    return new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 3
    }).format(truncated);
  };
  const cols = useMemo(
    () => [
      {
        title: "Name",
        data: "uname",
        responsivePriority: 1,
        render: function (d, type, row) {
          const safe = escapeHtml(String(d ?? ""));
          const key = escapeHtml(String(row._dt_key ?? ""));
          return `<a href="#" class="dt-user-link site_family" data-row-key="${key}" style="color:#00b181;cursor:pointer">${safe}</a>`;
        }
      },
      {
        title: "Amount",
        data: "winAmount",
        render: (d) =>
          d < 0
            ? `<span style="color:red" class="site_family">${formatTruncate(
                Math.round(d)
              )}</span>`
            : `<span style="color:green" class="site_family">${formatTruncate(
                Math.round(d)
              )}</span>`,
        responsivePriority: 2
      },
      {
        title: "",
        data: "user_id",
        visible: false,
        render: (d) => `<span class="site_family">${d}</span>`,
        responsivePriority: 3
      }
    ],
    []
  );

  useEffect(() => {
    getFinalSheetData();
  }, []);

  const getFinalSheetData = async () => {
    let frm = toLocalString(startDate);
    let til = toLocalString(endDate);
    //setShowLoader(true);

    const response = await axiosInstance.post("master/get-finalsheet-data", {
      frm,
      til
    });
    setProfitData(response.data.plus);
    setAllProfitData(response.data.plus);

    setLossData(response.data.minus);
    setAllLossData(response.data.minus);

    setPlusTotal(response.data.plusTotal);
    setMinusTotal(response.data.minusTotal);
    setIsLoading(false);
    //setShowLoader(false);
    //console.log("Final Sheet Data:", response.data);
  };

  const handleHideZeroCheckbox = (e) => {
    setHideZero(e.target.checked);
    if (e.target.checked) {
      let newProfitData = [];

      profitData.forEach((data) => {
        if (data.winAmount != 0) {
          newProfitData.push(data);
        }
      });

      if (newProfitData.length > 0) {
        setProfitData(newProfitData);
      }

      let newLossData = [];
      lossData.forEach((data) => {
        if (data.winAmount != 0) {
          newLossData.push(data);
        }
      });

      if (newLossData.length > 0) {
        setLossData(newLossData);
      }
    } else {
      setProfitData(allProfitData);
      setLossData(allLossData);
    }
  };

  return (
    <AgentLayout>
      <div class="container-fluid">
        <div class="loader" id="data_loaded" style={{ display: "none" }}>
          <img src="/assets/images/loadinggif.gif" />
        </div>

        <div class="bets-section-wrapper">
          <div>
            <NavButton></NavButton>
          </div>
          {/* <button
            class="btn btn-success"
            style={{ background: "#02b181" }}
            type="button"
            onclick="updateFinalSheet()"
          >
            <strong>Update Final Sheet</strong>
          </button>
        */}
        </div>

        <div class="bets-wrapper" style={{ marginTop: "20px" }}>
          <div class="row">
            <div class="col-md-8" style={{ marginTop: "0px" }}>
              <div class="card">
                <div class="card-header">
                  <i class="fa fa-align-justify"></i>
                  <strong className="site_family">
                    {" "}
                    {username} - Final Sheet
                  </strong>
                  <br />

                  <div
                    class="pull-left site_family"
                    style={{ marginBottom: "1em" }}
                  >
                    <input
                      type="checkbox"
                      checked={hideZero}
                      onChange={handleHideZeroCheckbox}
                    />{" "}
                    Hide Zero Amounts
                  </div>
                </div>

                <div class="card-body">
                  <div class="row">
                    <div class="col-6">
                      <div
                        id="DataTables_Table_0_wrapper"
                        class="dataTables_wrapper dt-bootstrap4 no-footer"
                      >
                        <div class="row">
                          <div class="col-sm-12 col-md-6"></div>
                          <div class="col-sm-12 col-md-6"></div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            {profitData && (
                              <EasyGrid
                                responsiveMode="hybrid"
                                cols={cols}
                                dataset={profitData}
                                isLoading={isLoading}
                                pageSize={pageSize}
                                handleUserClick={handleUserClick}
                              ></EasyGrid>
                            )}
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12 col-md-5"></div>
                          <div class="col-sm-12 col-md-7"></div>
                        </div>
                      </div>
                    </div>

                    <div class="col-6">
                      <div class="dataTables_wrapper dt-bootstrap4 no-footer">
                        <div class="row">
                          <div class="col-sm-12 col-md-6"></div>
                          <div class="col-sm-12 col-md-6"></div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12">
                            {lossData && (
                              <EasyGrid
                                responsiveMode="hybrid"
                                cols={cols}
                                dataset={lossData}
                                isLoading={isLoading}
                                pageSize={pageSize}
                                handleUserClick={handleUserClick}
                              ></EasyGrid>
                            )}
                          </div>
                        </div>
                        <div class="row">
                          <div class="col-sm-12 col-md-5"></div>
                          <div class="col-sm-12 col-md-7"></div>
                        </div>
                      </div>
                    </div>

                    <div class="col-6">
                      <table class="table table-sm">
                        <tbody>
                          <tr style={{ background: "#00b281" }}>
                            <th
                              className="site_family"
                              style={{ fontWeight: "bold", color: "#ffffff" }}
                            >
                              Total
                            </th>
                            <th>
                              <span
                                className="site_family"
                                style={{ fontWeight: "bold", color: "#ffffff" }}
                              >
                                {formatTruncate(plusTotal)}
                              </span>
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </div>

                    <div class="col-6">
                      <table class="table table-sm">
                        <tbody>
                          <tr class="bg-danger">
                            <th
                              className="site_family"
                              style={{ fontWeight: "bold" }}
                            >
                              Total
                            </th>
                            <th>
                              <span
                                className="site_family"
                                style={{ fontWeight: "bold" }}
                              >
                                {formatTruncate(minusTotal)}
                              </span>
                            </th>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </AgentLayout>
  );
};

export default FinalSheet;
